xplenty.directive('packageVersionMessageForm', [
  function () {
    return {
      restrict: 'E',
      template:
        "<div class='package-json-import-form row'>" +
        "<span class='col-md-10 col-md-offset-1'>" +
        "{{'package_major_version_form.title' | translate}}<br/>" +
        "<textarea maxlength='255' class='form-control' ng-model='versionMessage'></textarea>" +
        '</span>' +
        '</div>',
      replace: true,
      scope: {
        versionMessage: '=ngModel',
      },
    };
  },
]);
